export const types = {
  CHANGE_ORGANIZATION_SITES_EDIT_MODE: 'CHANGE_ORGANIZATION_SITES_EDIT_MODE',
  SET_EDIT_FROM_ORGANIZATION_SITES: 'SET_EDIT_FROM_ORGANIZATION_SITES',
};
